var app;

- (- (- (-(app = window.App || (window.App = {})))));

app.FilterAttribute = {
  remove: function(e) {
    $(e.target).closest('.filter_attribute_form').remove();
    return e.preventDefault();
  },
  add: function(e) {
    var form;
    if (e.target.value === '') {
      return;
    }
    form = $('.filter_attribute_form_template').clone();
    app.FilterAttribute.duplicateAttributeForm(e, form);
    app.FilterAttribute.setAttributeNameTimestamp(form);
    return app.FilterAttribute.enableForm(form);
  },
  duplicateAttributeForm: function(e, form) {
    form.removeClass('filter_attribute_form_template');
    form.removeClass('d-none');
    form.find('.attribute_key_dropdown').val(e.target.value);
    form.find('.attribute_key_hidden_field').val(e.target.value);
    form.appendTo('#filter_attribute_forms');
    return e.target.value = '';
  },
  setAttributeNameTimestamp: function(form) {
    var time;
    time = new Date().getTime();
    app.FilterAttribute.renameAttributeName(form.find('.attribute_key_hidden_field'), time);
    app.FilterAttribute.renameAttributeName(form.find('.attribute_constraint_dropdown'), time);
    return app.FilterAttribute.renameAttributeName(form.find('.attribute_value_input'), time);
  },
  renameAttributeName: function(selector, time) {
    var regex;
    regex = /\[\d{13}\]/;
    selector.attr('name', selector.attr('name').replace(regex, "[" + time + "]"));
    return selector.attr('id', selector.attr('id').replace(/_\d{13}_/, "_" + time + "_"));
  },
  enableForm: function(form) {
    var field, type;
    field = form.find('.attribute_key_hidden_field').attr('value');
    type = form.closest('[data-types]').data('types')[field];
    if (!(type === 'integer')) {
      form.find('option[value=greater], option[value=smaller]').remove();
    }
    if (!(type === 'date')) {
      form.find('option[value=before], option[value=after]').remove();
    }
    if (!(type === 'string')) {
      form.find('option[value=match], option[value=not_match]').remove();
    }
    form.find('.attribute_key_hidden_field').removeAttr('disabled');
    form.find('.attribute_constraint_dropdown').removeAttr('disabled');
    Array.from(form.find('.attribute_value_input:not(.' + type + '_field)')).forEach((function(_this) {
      return function(element) {
        return element.remove();
      };
    })(this));
    form.find('.attribute_value_input[data-attr-key]').filter(function() {
      return $(this).data('attrKey') !== field;
    }).remove();
    return form.find('.' + type + '_field').removeAttr('disabled');
  },
  toggleValueVisibility: function(e) {
    var input;
    input = $(e.target).closest(".filter_attribute_form").find(".attribute_value_input");
    if (e.target.value === "blank") {
      return input.addClass("invisible");
    } else {
      return input.removeClass("invisible");
    }
  }
};

$(document).on('change', '#attribute_filter', app.FilterAttribute.add);

$(document).on('click', '.remove_filter_attribute', app.FilterAttribute.remove);

$(document).on('click', '.attribute_constraint_dropdown', app.FilterAttribute.toggleValueVisibility);
